<template>
  <input
    v-model="stateValue"
    type="range"
    class="music-player-progress"
    :style="{ backgroundSize: `${percentage}% 100%` }"
    step="1"
    min="0"
    :max="max"
    @mousedown="onMouseDown"
    @touchstart="onMouseDown"
    @mouseup="onMouseUp"
    @touchend="onMouseUp"
    @mousemove="onMouseMove"
  >
</template>

<script>
import _ from 'lodash'

export default {
  name: 'MusicPlayerProgress',
  props: {
    max: {
      type: Number,
      default: 0
    },
    value: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      stateValue: 0,
      isSeeking: false
    }
  },
  computed: {
    percentage () {
      const { max, stateValue } = this
      const iMax = parseFloat(max)
      const iValue = parseFloat(stateValue)
      return _.ceil(iValue * 100 / iMax)
    }
  },
  watch: {
    value (value) {
      const { isSeeking } = this
      if (isSeeking) return

      this.stateValue = value
    }
  },
  methods: {
    onMouseDown () {
      this.isSeeking = true
      this.$emit('seek')
    },
    onMouseMove () {
      const { isSeeking } = this
      if (!isSeeking) return

      const { target } = event
      this.$emit('seeking', target.value)
    },
    onMouseUp (event) {
      this.isSeeking = false
      const { target } = event
      this.$emit('seeked', target.value)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'

$track-height = 2px;
$thumb-size = 10px;

thumb() {
  width: $thumb-size;
  height: $thumb-size;
  background-color: $white;
  opacity: 0;
  border-radius: 50%;
  transition: opacity 0.2s;
  appearance: none;
}

thumb-when-track-hover() {
  opacity: 1;
}

.music-player-progress {
  width: 100%;
  height: $track-height;
  margin: 0;
  border-radius: 5px;
  outline: 0;
  appearance: none;
  user-select: none;
  background: linear-gradient(#FFF, #FFF) no-repeat #777;
  background: -moz-linear-gradient(#FFF, #FFF) no-repeat #777;
  background-size: 0% 100%;
  cursor: pointer;

  &::-webkit-slider-thumb {
    thumb();
  }

  &::-moz-range-thumb {
    thumb();
  }

  &:hover,
  &:active {
    &::-webkit-slider-thumb {
      thumb-when-track-hover();
    }

    &::-moz-range-thumb {
      thumb-when-track-hover();
    }
  }
}
</style>
